import { render, staticRenderFns } from "./digital-twin.vue?vue&type=template&id=5f27041e&scoped=true&"
import script from "./digital-twin.vue?vue&type=script&lang=js&"
export * from "./digital-twin.vue?vue&type=script&lang=js&"
import style0 from "./digital-twin.vue?vue&type=style&index=0&id=5f27041e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27041e",
  null
  
)

export default component.exports